/**
* specifies which @ngrx dev tools will be available when you build and load
* your app in dev mode. Options are: monitor | logger | both | none
*/
//export const STORE_DEV_TOOLS = 'monitor'
export const STORE_DEV_TOOLS: string = 'monitor'


// WEBPACK FOOTER //
// ./src/app/constants/globals.ts